module.exports = __webpack_public_path__ + "img/partners.96b85a51.svg";